import './SearchResult.scss'

import {Background} from '@codeurs/front'
import placeholder from 'assets/images/placeholder.png'
import React from 'react'
import parse from 'url-parse'
import {ImageType, WysiwygType} from '../../../types'
import {Link} from '../../../util/link'
import {style} from '../../../util/style'
import {Theme} from '../../Theme'

const styles = style('searchresult', ['image'])

export type SearchResultType = {
	url: string
	title: string
	image?: ImageType
	subtitle?: string
	text?: WysiwygType
}

export const SearchResult: React.FC<SearchResultType & {term: string}> = ({
	url,
	title,
	image,
	subtitle,
	text,
	term
}) => {
	const textPreview = (t: string) => {
		if (t.length < 400) return t
		return t.replace(/(^[\s\S]{380,}?\b)[\s\S]*/g, '$1').trim() + '...'
	}

	const domainLink = (l: string) => {
		const parsed = parse(l)
		if (parsed.hostname !== window.location.hostname) return l
		return l.replace(/http[s]?:\/\//g, '').replace(parsed.hostname, '')
	}

	const termBold = (t: string) => {
		const regEx = new RegExp('(' + term + ')', 'ig')
		return t.replace(regEx, `<b>$1</b>`)
	}

	return (
		<Link to={domainLink(url)} target="_blank" className={styles()}>
			<Theme.H2
				className={styles('title')}
				mod="green"
				dangerouslySetInnerHTML={{__html: termBold(title)}}
			/>
			<div className={styles('row')}>
				<div className={styles('image')}>
					<SearchResultImage image={image} />
				</div>
				<div className={styles('content')}>
					{subtitle && (
						<Theme.H5 className={styles('content-subtitle')}>
							{subtitle}
						</Theme.H5>
					)}
					{text && (
						<div className={styles('content-text')}>
							<Theme.Wysiwyg>{termBold(textPreview(text))}</Theme.Wysiwyg>
						</div>
					)}
				</div>
			</div>
			<p className={styles('link')}>{url}</p>
		</Link>
	)
}

export const SearchResultImage: React.FC<{image: ImageType}> = ({image}) => {
	return (
		<div className={styles.image()}>
			<Background
				img={image || placeholder}
				className={styles.image('bg').toString()}
			/>
			<span className={styles.image('overlay')} />
		</div>
	)
}
